var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",attrs:{"id":"InstitutionsView"}},[_c('BaseBreadcrumb',{attrs:{"items":_vm.breadcrumbItems}}),_c('div',{staticClass:"page-list"},[_c('BContainer',[_c('InstitutionList')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }